import React, { useEffect, useState } from 'react';
import url from '../../../../serverUrl';
import { api as axios } from '../../../../api';
import { fmtUsd } from './format';
import './pro.css';

// Thin status strip at the foot of the trade screen: API health + latency,
// latest synced block, PECU price and UTC clock.
export default function StatusBar({ PecuPrice }) {
  const [state, setState] = useState({ ok: null, ms: null, block: null });
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let cancelled = false;
    let timer;
    const ping = () => {
      const t0 = performance.now();
      axios
        .get(`${url}/wallet/latestSyncedBlock`, { timeout: 10000 })
        .then((res) => {
          if (cancelled) return;
          const d = res.data;
          const block = d?.block_length ?? d?.block ?? (typeof d === 'number' ? d : null);
          setState({ ok: true, ms: Math.round(performance.now() - t0), block });
        })
        .catch(() => !cancelled && setState((s) => ({ ...s, ok: false, ms: null })))
        .finally(() => {
          if (!cancelled) timer = setTimeout(ping, 15000);
        });
    };
    ping();
    const clock = setInterval(() => setNow(new Date()), 1000);
    return () => {
      cancelled = true;
      clearTimeout(timer);
      clearInterval(clock);
    };
  }, []);

  const label = state.ok === null ? 'Connecting' : state.ok ? (state.ms > 2500 ? 'Degraded' : 'Operational') : 'Reconnecting';
  const cls = state.ok === null ? 'x-st-wait' : state.ok ? (state.ms > 2500 ? 'x-st-warn' : 'x-st-ok') : 'x-st-bad';

  return (
    <div className="x-statusbar">
      <span className={`x-st ${cls}`}>
        <i /> {label}
        {state.ms !== null && <span className="x-muted"> · {state.ms} ms</span>}
      </span>
      {state.block !== null && state.block !== undefined && (
        <span className="x-muted">
          Block{' '}
          <span className="x-text">
            #{Number.isFinite(Number(state.block)) ? Number(state.block).toLocaleString('en-US') : state.block}
          </span>
        </span>
      )}
      {PecuPrice ? (
        <span className="x-muted">
          PECU <span className="x-text">{fmtUsd(PecuPrice)}</span>
        </span>
      ) : null}
      <span className="x-flex" />
      <a href="https://www.hootdex.net/support" target="_blank" rel="noreferrer" className="x-muted">
        Support
      </a>
      <span className="x-muted x-mono">{now.toISOString().slice(11, 19)} UTC</span>
    </div>
  );
}
